import { Button, Icon } from "@chakra-ui/react";
import { FaWhatsapp } from "react-icons/fa";
import { useEffect, useState } from "react";

interface FloatingHelpButtonProps {
	whatsappNumber?: string;
	message?: string;
}

export const FloatingHelpButton = ({
	whatsappNumber = "2349161234567", // Default to your team's WhatsApp number
	message = "Hi! I need help with my LaborHack account.",
}: FloatingHelpButtonProps) => {
	const [showButton, setShowButton] = useState(false);
	const [isBouncing, setIsBouncing] = useState(true);

	// Show button after 2 seconds delay
	useEffect(() => {
		const showTimer = setTimeout(() => {
			setShowButton(true);
		}, 2000);

		return () => clearTimeout(showTimer);
	}, []);

	// Stop bouncing after 5 seconds
	useEffect(() => {
		if (showButton) {
			const timer = setTimeout(() => {
				setIsBouncing(false);
			}, 5000);

			return () => clearTimeout(timer);
		}
	}, [showButton]);

	const handleWhatsAppClick = () => {
		const encodedMessage = encodeURIComponent(message);
		const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
		window.open(whatsappUrl, "_blank");
	};

	// Don't render until delay is over
	if (!showButton) return null;

	return (
		<Button
			position="fixed"
			bottom="20px"
			left="20px"
			zIndex={999}
			onClick={handleWhatsAppClick}
			size="md"
			bg="#25D366"
			color="white"
			borderRadius="full"
			boxShadow={
				isBouncing
					? "0 6px 20px rgba(37, 211, 102, 0.5)"
					: "0 4px 12px rgba(37, 211, 102, 0.4)"
			}
			transition="all 0.3s ease-in-out"
			className={isBouncing ? "animate-bounce" : ""}
			style={{
				animationDuration: isBouncing ? "1.5s" : "0s",
			}}
			_hover={{
				bg: "#128C7E",
				boxShadow: "0 6px 20px rgba(37, 211, 102, 0.6)",
				transform: "translateY(-2px)",
			}}
			leftIcon={
				<Icon
					as={FaWhatsapp}
					w={4}
					h={4}
					color="white"
				/>
			}
			px={4}
			py={2}
			fontSize="sm"
			fontWeight="medium"
		>
			Need Help?
		</Button>
	);
};
